<template>
  <v-btn
    :disabled="!apps || !apps.length || apps.length !== 1"
    color="blue-grey"
    class="nlp-nav-btn mx-0"
    style="border-top-left-radius: 0; border-bottom-left-radius: 0"
    small
    outline
    @click="handleClick"
  >
    <v-dialog v-model="confirmDialog" max-width="590">
      <v-card class="border-radius-standard">
        <v-card-title class="headline">
          Import App
          <v-spacer />
          <v-icon @click="confirmDialog = false">close</v-icon>
        </v-card-title>

        <v-card-text>
          <p style="font-size: 120%">
            Are you sure you want to import this app?
          </p>
          <v-alert
            :value="true"
            color="amber darken-3"
            icon="info"
            class="border-radius-standard"
            outline
          >
            Notice: "Import" will totally override the existing intents.
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <!-- <v-btn
            color="error"
            flat
            style="font-size: 120%"
            @click="confirmDialog = false"
          >
            Cancel
          </v-btn> -->

          <v-spacer />

          <v-btn
            color="primary"
            style="font-size: 120%"
            @click="accept({ override_intents: true })"
          >
            Import
          </v-btn>
          <!-- <v-btn
            color="green darken-1"
            style="font-size: 120%"
            outline
            @click="accept({ override_intents: false })"
          >
            Import 
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-icon> south </v-icon>
    Import
    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept=".json,.lu"
      @change="onFileChanged"
    />
  </v-btn>
</template>

<script>
export default {
  name: "ImportApp",
  props: {
    apps: {
      type: Array,
      required: null,
    },
  },
  data() {
    return {
      selectedFile: null,
      isSelecting: false,
      extractedData: {},
      confirmDialog: false,
      fileModel: null,
    };
  },
  watch: {
    confirmDialog(val) {
      if (!val) {
        this.selectedFile = null;
        this.$refs.uploader.value = null;
      }
    },
    selectedFile: {
      deep: true,
      handler(val) {
        if (val) this.confirm();
      },
    },
  },
  methods: {
    handleClick() {
      this.isSelecting = true;
      window.addEventListener("focus", () => {
        this.isSelecting = false;
      });

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      window.fue = this.selectedFile;
      this.confirm();
    },
    confirm() {
      this.confirmDialog = true;
    },
    accept(extraPayload) {
      // if(this.selectedFile.type === 'application/json') {
      this.formatFile(this.selectedFile, extraPayload);
      // } else {
      //   this.uploadFile()
      // }
    },
    async formatFile(file = this.selectedFile, extraPayload) {
      file.text().then(async (text) => {
        try {
          this.$store.dispatch("setLoader", true);
          if (this.selectedFile.type === "application/json") {
            this.extractedData = { ...JSON.parse(text), ...extraPayload };
          } else {
            let formObject = new FormData();
            formObject.append("file", this.selectedFile);
            this.extractedData = formObject;
          }

          await this.importSingleApp(this.extractedData);
          this.$store.dispatch("setSnackbar", {
            text: `Imported`,
            color: "success",
          });
          this.$store.dispatch("setLoader", false);
          this.$emit("success");
          this.confirmDialog = false;
          this.$refs.uploader.value = null;
          this.selectedFile = null;
        } catch (err) {
          this.$store.dispatch("setLoader", false);
          this.$store.dispatch(
            "setErrorMessage",
            err && err.response && err.response.data && err.response.data.error
              ? err.response.data.error
              : true
          );
          console.log(err);
        }
      });
    },
    async uploadFile() {
      try {
        this.$store.dispatch("setLoader", true);
        this.extractedData = { ...JSON.parse(text), ...extraPayload };
        await this.importSingleApp(this.extractedData);
        this.$store.dispatch("setSnackbar", {
          text: `Imported`,
          color: "success",
        });
        this.$store.dispatch("setLoader", false);
        this.$emit("success");
        this.confirmDialog = false;
        this.$refs.uploader.value = null;
        this.selectedFile = null;
      } catch (err) {
        this.$store.dispatch("setLoader", false);
        this.$store.dispatch(
          "setErrorMessage",
          err && err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : true
        );
      }
    },
    async importSingleApp(app) {
      try {
        const response = await this.$http_nlp({
          url: `/apps/${this.apps[0].id}/import`,
          data: app,
          method: "post",
          timeout: 900000,
        });
        return true;
      } catch (err) {
        throw err;
        return false;
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
